<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>店铺装修</el-breadcrumb-item>
            <el-breadcrumb-item>轮播图</el-breadcrumb-item>
        </el-breadcrumb>
        <!--		数据是list 通过list展示-->
        <div class="btns">
            <el-button type="primary" size="small" @click="add" v-auth="['store/fitment.swiper/add']">添加轮播图</el-button>
        </div>
        <el-table :data="list" border>
            <el-table-column label="图片">
				<template slot-scope="scope">
					<div id="" style="display: flex;align-items: center;">
						<img :src="scope.row.image" style="width: 60px;">
					</div>
				</template>
			</el-table-column>
            <el-table-column prop="url" label="链接"></el-table-column>
            <el-table-column prop="type" label="类型">
				<template slot-scope="scope">
					<div v-if="scope.row.positions == 1">
						首页头部
					</div>
					<div v-else-if="scope.row.positions == 2">
						首页中部
					</div>
					<div v-else-if="scope.row.positions == 3">
						发现页面
					</div>
					<div v-else-if="scope.row.positions == 4">
						商品页面
					</div>
					<div v-else="scope.row.positions == 5">
						我的页面
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="orders" label="排序"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['store/fitment.swiper/edit']">编辑</el-button>
                    <el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-auth="['store/fitment.swiper/delete']">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
					:current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list: [],
                isLoad: false,
				// 每页多少条数据
				pageSize: 20,
				total: 0,
				// 当前在第几页
				page: 1,
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/store/fitment.swiper/list', {
					page: this.page,
					pagesize: this.pageSize
                })
				.then(res => {
					this.isLoad = !this.isLoad
					// 获取数据
					this.list = res.data.list.data
					this.total = res.data.list.total
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
            },
            // 跳转到edit添加
            add() {
                this.$router.push({path: '/ShoppingMall/swiperEdit.html'});
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(id) {
                this.$router.push({
                    path: '/ShoppingMall/swiperEdit.html',
                    query: {
                        id: id
                    }
                });
            },
            //
            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.post('/store/fitment.swiper/delete', {
                    id
                })
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose: false
                        });
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped>
</style>
